/**
 * Clownfish Voice Changer for Chrome — real-time microphone voice changer
 *
 * Declares one web-accessible-resource entry matched to every origin with no dynamic URL,
 * listing contentBody.js, CF.js, CF.wasm and the glob res/*.png. The vendor-named CF.wasm
 * is distinctive and fetchable at a fixed URL, while the res/ icons load through probeImage
 * with no CORS grant.
 *
 * Manifest verified against version 0.3.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'dmgaboifbpokjbdcbnmkcohiondlampj';

export const clownfishVoiceChanger: ExtensionDefinition = {
  id: ID,
  name: 'Clownfish Voice Changer for Chrome',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 70_000,
  notes:
    'contentBody.js, CF.js, CF.wasm and res/*.png exposed to every origin with no dynamic ' +
    'URL. The res/ icons load without a CORS grant; CF.wasm corroborates by fetch.',
  signals: [
    {
      id: 'war-microphone-png',
      kind: 'web-accessible-resource',
      description:
        'Load res/Microphone.png via <img> — a bundled icon matched by the res/*.png WAR ' +
        'glob on every origin, readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'res/Microphone.png'),
    },
    {
      id: 'war-cf-wasm',
      kind: 'web-accessible-resource',
      description:
        'Fetch CF.wasm — the vendor-named WebAssembly module, a distinctive path exposed ' +
        'to every origin.',
      weight: 0.5,
      run: () => probeFetch(ID, 'CF.wasm'),
    },
    {
      id: 'war-content-body-js',
      kind: 'web-accessible-resource',
      description: 'Fetch contentBody.js — the injected content script, a third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'contentBody.js'),
    },
  ],
};
